import { differenceInDays, isValid, parseISO, toDate } from 'date-fns';

export function isoDifferenceInDaysToNow(date: string): number {
  return differenceInDays(parseISO(date), toDate(new Date())) + 1;
}

export function toISOString(date: Date | string | number | undefined): string {
  if (!date || date === 'Invalid date') {
    return 'Invalid date';
  }

  const dateInstance: Date = new Date(date);

  return isValid(dateInstance) ? dateInstance.toISOString() : 'Invalid date';
}
